import CitySEOHead from "@/components/feature/CitySEOHead";
import OmahaHeroSection from "./components/HeroSection";
import OmahaStickyNav from "./components/StickyNav";
import OmahaOfficeInfoSection from "./components/OfficeInfoSection";
import OmahaProcessingTimeSection from "./components/ProcessingTimeSection";
import OmahaLocalAreaSection from "./components/LocalAreaSection";
import OmahaServicesSection from "./components/ServicesSection";
import OmahaTravelTimingSection from "./components/TravelTimingSection";
import OmahaDestinationsSection from "./components/DestinationsSection";
import OmahaTestimonialsSection from "./components/TestimonialsSection";
import OmahaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import OmahaComparisonSection from "./components/ComparisonSection";
import OmahaMistakesSection from "./components/MistakesSection";
import OmahaHowItWorksSection from "./components/HowItWorksSection";
import OmahaFAQSection, { faqs } from "./components/FAQSection";
import OmahaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import OmahaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function OmahaPage() {
  return (
    <>
      <CitySEOHead
        city="Omaha"
        state="Nebraska"
        stateAbbr="NE"
        route="/cities/omaha"
        officeHours={[
          { dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "08:00", closes: "18:00" },
          { dayOfWeek: "Saturday", opens: "09:00", closes: "14:00" },
        ]}
        title="Emergency Passport Omaha, NE — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Omaha, NE — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Offutt AFB STRATCOM families, Fortune 500 business travelers, Creighton and UNO students, and Eastern Nebraska residents."
        geoPlacename="Omaha, Nebraska"
        geoPosition="41.2565;-95.9345"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Nebraska"
        statePageRoute="/states/nebraska"
        ogImage="https://static.readdy.ai/image/ab5c41a1d5d093e183ae5e5120d5853b/1872ed8cda381c0ff8576385f08c39ab.png"
        areaServedList={[
          { "@type": "City", "name": "Omaha" },
          { "@type": "City", "name": "Bellevue" },
          { "@type": "City", "name": "Council Bluffs" },
          { "@type": "City", "name": "Lincoln" },
          { "@type": "City", "name": "Papillion" },
          { "@type": "City", "name": "Elkhorn" },
          { "@type": "City", "name": "La Vista" },
          { "@type": "AdministrativeArea", "name": "Douglas County" },
          { "@type": "AdministrativeArea", "name": "Sarpy County" },
          { "@type": "AdministrativeArea", "name": "Pottawattamie County" },
          { "@type": "AdministrativeArea", "name": "Lancaster County" },
        ]}
        serviceAreaDesc="Fast Passport Center has a physical office at 1601 Dodge St in downtown Omaha, providing emergency and expedited passport services as fast as 24 hours. A+ BBB rated registered U.S. Department of State passport courier serving Omaha, Bellevue, Council Bluffs, Lincoln, Papillion, and all Eastern Nebraska and Western Iowa communities."
      />
      <div className="font-sans">
        <OmahaHeroSection />
        <OmahaStickyNav />
        <OmahaOfficeInfoSection />
        <OmahaLocalAreaSection />
        <OmahaProcessingTimeSection />
        <OmahaServicesSection />
        <OmahaTravelTimingSection />
        <OmahaDestinationsSection />
        <OmahaTestimonialsSection />
        <OmahaAcceptanceFacilitiesSection />
        <OmahaComparisonSection />
        <OmahaMistakesSection />
        <OmahaHowItWorksSection />
        <OmahaFAQSection />
        <OmahaHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/omaha" state="NE" />
        <OmahaFinalCTA />
      </div>
    </>
  );
}